<template>
  <div class="toast-wrapper">
    <div class="toast">
      <div class="flex justify-between items-start">
        <div style="width: 24px" />
        <img 
          :src="image_base_url + 'orderTest/floatingNotice/firework.svg'" 
          class="mt-3"
        >
        <button @click="handleClickClear()">
          <img
            src="@/assets/orderTest/floatingNotice/clear_24px.svg" 
            alt=""
          >
        </button>
      </div>
      <div class="toast-row mt-3">
        <img 
          src="@/assets/orderTest/floatingNotice/unlock.svg" 
          class="toast-icon"
        >
        <div class="toast-msg">
          <span>{{ $t("OrderPage[\"A special deal unlocked!\"]") }}</span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  inject: ['image_base_url'],
  methods: {
    handleClickClear() {
      this.$emit("close");
    }
  }
}
</script>

<style>
  .toast-wrapper {
    position: fixed;
    right: 24px;
    top: 12px;
    z-index: 2147483647;
    pointer-events: none;
  }
  .toast {
    width: 310px;
    height: 142px;

    padding: 20px;
    background: #000000;
    border-radius: 10px;
    box-shadow: 1px 3px 5px rgba(0,0,0,0.2);
    margin: 0 auto;

    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 17px;
    /* identical to box height, or 106% */

    letter-spacing: 0.4004px;
    color: #FFFFFF;
    pointer-events: auto;
  }
  .toast-row{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  .toast-icon{
    width: 24px;
    height: 24px;
    flex: 0 0 auto;
    align-self: flex-start;
  }

  .toast-msg{
    margin: 0;
    display: block;
    max-width: 220px;
    text-align: center;
    line-height: 1.35;
    white-space: normal;
    word-break: break-word;
  }
</style>